<template>
    <div>
        <button :class="classes" class="w-full text-left" v-if="as === 'button'">
            <slot></slot>
        </button>

        <Link :href="href" :class="classes" v-else>
            <slot></slot>
        </Link>
    </div>
</template>

<script>
export default {
    props: ["active", "href", "as"],

    computed: {
        classes() {
            return this.active
                ? "block pl-4 pr-4 py-3 border-l-4 border-indigo-400 text-sm text-indigo-700 bg-indigo-50 focus:outline-none focus:text-indigo-800 focus:bg-indigo-100 focus:border-indigo-700 transition duration-150 ease-in-out"
                : "block pl-4 pr-4 py-3 border-l-4 border-transparent text-sm text-gray-700 hover:text-gray-800 hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:text-gray-800 focus:bg-gray-50 focus:border-gray-300 transition duration-150 ease-in-out"
        },
    },
}
</script>
